import { render, staticRenderFns } from "./change-user-status-button.vue?vue&type=template&id=905e6d6c&scoped=true&"
import script from "./change-user-status-button.vue?vue&type=script&lang=js&"
export * from "./change-user-status-button.vue?vue&type=script&lang=js&"
import style0 from "./change-user-status-button.vue?vue&type=style&index=0&id=905e6d6c&lang=scss&scoped=true&"
import style1 from "./change-user-status-button.vue?vue&type=style&index=1&id=905e6d6c&lang=scss&scoped=true&"
import style2 from "./change-user-status-button.vue?vue&type=style&index=2&id=905e6d6c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "905e6d6c",
  null
  
)

export default component.exports
import {QTabs,QTab,QBtnToggle,QTabPanel} from 'quasar'
component.options.components = Object.assign(Object.create(component.options.components || null), component.options.components || {}, {QTabs,QTab,QBtnToggle,QTabPanel})
